<template>
    <div class="col-sm-12 list-content-item mb-2">
        <div class="row">
            <div class="col-auto image-container">
                <avatar-badge :src="displayImage" :raised="false" :size="100"></avatar-badge>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col-lg-9">
                        <router-link :to="shopLink" target="_blank">
                            <h2 class="title link-hover-line" v-text="shop.name"></h2>
                        </router-link>
                    </div>
                </div>
                <div class="description" v-text="displayedAddress"></div>
                <div class="description mb-3" v-text="displayedPriceRange"></div>
                <div v-if="isLoggedIn">
                    <a v-if="!isFavorite" href="add-to-favorites" @click.prevent="addToFavorites" class="text-sm link-hover-line text-warning">
                        <i class="fas fa-heart mr-1"></i> Add to favorites
                    </a>
                    <a v-else href="add-to-favorites" @click.prevent="removeFromFavorites" class="text-sm link-hover-line text-danger">
                        <i class="fas fa-ban mr-1"></i> Remove to favorites
                    </a>
                </div>
                <div class="text-right" style="margin-top: -40px;">
                    <button @click="select" class="btn btn-warning">
                        Select <i class="fas fa-angle-right ml-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { route, pageRoute, post, destroy } from "@utils/network";
import mixins from "@utils/mixins";

export default {
    name: "ShopListItem",

    computed: {
        isLoggedIn() {
            return this.$store.getters.userToken != null;
        },
        displayImage() {
            return this.shop.display_image || "/images/placeholders/avatar.jpg";
        },
        displayedAddress() {
            return this.shop.address ? this.shop.address.display_name : "";
        },
        displayedPriceRange() {
            return `PHP${ this.shop.min_price } - PHP${ this.shop.max_price }`;
        },
    },

    data() {
        return {
            shopLink: pageRoute('/shops/:id/about', { id: this.shop.id }, false),
            isFavorite: !!this.shop.is_favorite,
        }
    },

    methods: {
        select() {
            this.$emit("select", {...this.shop});
        },
        async addToFavorites() {
            if (!(await this.confirm("Are you sure you want to add this shop from your favorites?", "")).value) {
                return;
            }
            post(route("customers/favorite-shops/add"), { params: { shop_id: this.shop.id } })
                .then(response => {
                    this.promptMessage(response.data.message.message, "");
                    this.isFavorite = true;
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                });
        },
        async removeFromFavorites() {
            if (!(await this.confirm("Are you sure you want to remove this shop from your favorites?", "")).value) {
                return;
            }
            destroy(route("customers/favorite-shops/remove"), { params: { shop_id: this.shop.id } })
                .then(response => {
                    this.promptMessage(response.data.message.message, "");
                    this.isFavorite = false;
                })
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                });
        },
    },

    mixins: [mixins],
    
    props: {
        shop: [Object],
    },

    mounted() {

    }
}
</script>